export async function getFunctionsErrorDetails(error, fallbackMessage) {
  const response = error?.context;
  if (!response || typeof response.clone !== "function") {
    return error?.message || fallbackMessage;
  }

  try {
    const payload = await response.clone().json();
    return payload?.message || payload?.details || error.message || fallbackMessage;
  } catch {
    try {
      const text = await response.clone().text();
      return text || error.message || fallbackMessage;
    } catch {
      return error?.message || fallbackMessage;
    }
  }
}
